import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'leaflet/dist/leaflet.css'
import App from './App'
import Aufgaben from './pages/Aufgaben'

// ?aufgaben=1 oeffnet die gemeinsame Aufgaben-Testansicht statt des Cockpits.
// Bewusst hier und nicht in App.jsx: die Ansicht braucht keinen der vielen
// App-Zustaende, und so bleibt der Eingriff ins Cockpit auf diese Zeile
// beschraenkt. Die Anmeldung gilt trotzdem (gleicher Session-Cookie).
const istAufgabenAnsicht = new URLSearchParams(window.location.search).has('aufgaben')

ReactDOM.createRoot(document.getElementById('root')).render(
  istAufgabenAnsicht ? <Aufgaben /> : <App />
)
